import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Button from '../../../../button';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import ApiDatabase from 'server';
import StyledInput from '../../../../styledInput/StyledInput';

const ModalMissionCancel = () => {
  const { toggle } = useModal();
  const { objID, setModalDataReturn, updateMissionStatusLocal } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const [reasons, setReasons] = useState([]);
  const [reasonSelected, setReasonSelected] = useState('');
  const [isWaiting, setIsWaiting] = useState(true);
  const token = localStorage.getItem('xsrfToken');

  useEffect(() => {
    setIsWaiting(true);
    ApiDatabase.getReasonsMissionSuspension(
      { type: 'cancellation' },
      (data) => {
        setReasons(data);
        setIsWaiting(false);
      },
      (err) => {
        console.error(err);
        setIsWaiting(false);
      }
    );
  }, []);

  const handleSubmit = () => {
    if (!token || !objID || !reasonSelected) {
      toast.error('Veuillez sélectionner un motif');
      return;
    }
    setIsLoading(true);
    ApiDatabase.updateMissionStatus(
      { token, idMission: objID, newStatus: 'canceled', reason: reasonSelected },
      () => {
        updateMissionStatusLocal(objID, { status: 'canceled', reason: reasonSelected });
        setModalDataReturn('mission_status_updated');
        toast.success('La mission a été annulée');
        setIsLoading(false);
        toggle();
      },
      (err) => {
        toast.error("Erreur lors de l'annulation : " + err);
        setIsLoading(false);
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Annuler la mission
      </Modalheader>
      <ModalBody>
        {isWaiting ? (
          <div className="flex flex-col gap-3 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4" />
            <div className="h-4 bg-gray-200 rounded w-20" />
            <div className="h-10 bg-gray-200 rounded w-full" />
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            <p>Veuillez indiquer le motif d'annulation de la mission</p>
            <StyledInput
              type="select"
              label="Motif"
              placeholder="Sélectionnez un motif"
              value={reasonSelected}
              onChange={(e) => setReasonSelected(e.target.value)}
              list={reasons.map((r) => ({ value: r.name, label: r.name }))}
            />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size="LG" color="SECONDARY" onClick={toggle}>
          Annuler
        </Button>
        {isLoading ? (
          <Button size="LG" color="DISABLED">
            Confirmation ...
          </Button>
        ) : (
          <Button size="LG" color="PRIMARY" onClick={handleSubmit} disabled={isWaiting}>
            Confirmer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalMissionCancel;
